// extracted by mini-css-extract-plugin
export default {"healthWrap":"healthCareItem_healthWrap__NzV4a"};